import {
  faireDirectBrandAlias,
  faireDirectSalesRepCode,
} from "@faire/retailer-visitor-shared/app/_lib/data/faireDirect";
import { getExternalSalesRepName } from "@faire/retailer-visitor-shared/serialized-data/getExternalSalesRepName";
import { getFaireDirectBrandAlias } from "@faire/retailer-visitor-shared/serialized-data/getFaireDirectBrandAlias";
import { getFaireDirectBrandToken } from "@faire/retailer-visitor-shared/serialized-data/getFaireDirectBrandToken";
import { useSettingDecentralizePageData } from "@faire/retailer-visitor-shared/settings/useSettingDecentralizePageData";
import { useQuery as useFaireDirectInfoQuery } from "@faire/web-api--source/endpoints/www/api/page-data/faire-direct-info/brandAlias/get-hooks";
import qs from "query-string";
import { useLocation } from "react-router-dom";

export const useFaireDirectInfo = () => {
  const settingDecentralizePageData = useSettingDecentralizePageData();

  const { pathname, search } = useLocation();
  const queryParams = qs.parse(search);
  const brandAlias = faireDirectBrandAlias(pathname, queryParams) ?? "";
  const salesRepCode = faireDirectSalesRepCode(pathname);

  const { data } = useFaireDirectInfoQuery(
    brandAlias,
    { salesRepCode },
    {
      staleTime: Infinity,
      enabled: !!brandAlias && settingDecentralizePageData,
    }
  );

  return {
    faireDirectBrandAlias: settingDecentralizePageData
      ? data?.faire_direct_brand_alias
      : getFaireDirectBrandAlias(),
    faireDirectBrandToken: settingDecentralizePageData
      ? data?.faire_direct_brand_token
      : getFaireDirectBrandToken(),
    salesRepName: settingDecentralizePageData
      ? data?.external_sales_rep_name
      : getExternalSalesRepName(),
  };
};
